import { format } from 'date-fns/format'

import type { Language } from '@/shared/lib/i18n'
import { dateLocales } from '@/shared/lib/i18n/date-locales'

export function formatDateTime(date: Date, lang: Language, formatString = 'Pp'): string {
    return format(date, formatString, { locale: dateLocales[lang] })
}
